module.exports = ".question h1{\n    margin-top: 0;\n}\n\n"